<script>
import ChineseFields from '@phoenix/mixins/components/myAccount/addresses/ChineseFields';

export default {
  mixins: [ChineseFields],
};
</script>

<template>
  <div class="w-full">
    <form-group :attrs="fields.address9">
      <select-field v-model="fields.address9.value" />
    </form-group>
  </div>

  <div class="w-full">
    <form-group :attrs="fields.address7">
      <select-field
        v-model="fields.address7.value"
        :empty-choice="true"
        :disabled="fields.address7.options.length === 0"
      />
    </form-group>
  </div>

  <div class="w-full">
    <form-group :attrs="fields.address8">
      <select-field
        v-model="fields.address8.value"
        :empty-choice="true"
        :disabled="fields.address8.options.length === 0"
      />
    </form-group>
  </div>
</template>
